import React from 'react';
import { Flex } from '@components';
import { Form, Input, Button, Radio, Spin, message, Modal } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import CommonTip from "@pages/SelfHelp/common";
import NextButton from '@pages/SelfHelp/common/nextIndex';
import Hint from "@pages/SelfHelp/common/hint";
import NHFormItem from "@components/common/NHFormItem";
import NHSelect from "@components/common/NHSelect";
import { createUuid, getLoginUser } from '@utils/NHCore';
import NHFetch from "@utils/NHFetch";
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'

const FormItem = Form.Item;
const { confirm } = Modal
const RadioGroup = Radio.Group;
const basePath = '/sdcsjszyxy/zzbd/csypgm';

@Form.create()
export default class BeddingPurchase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD051',
            hjmc: '',
            nextUrl: '',
            search: '',
            operable: true,
            nd: '',
            nonOperationalData: {},
            csyplx: '', // 床上用品类型
            lyqd: '', // 来源渠道
            scqy: '', // 生产企业
            data: {},
            editable: true,
            loading: false,
            saveLoading: false,
            xssfytj:'', //学生是否已提交
            csypgmxz:'', //床上用品购买须知富文本
            hjyxxzs: '',
            xgcsypcsxx: '',
            showNotice: false,
        };
    }

    componentDidMount() {
        this.getXsCsypgmPz();
        this.queryQztjAndYlhj();
    }

    processHtmlContent = (html) => {
        if (!html) return '';
        // 移除可能导致布局问题的样式
        return html.replace(/text-wrap-mode:\s*nowrap/g, '');
      };

    showNoticeModal = (content) => {
        console.log('content', content);
        Modal.info({
            title: '内容须知',
            content: (
                <div dangerouslySetInnerHTML={{ __html: this.processHtmlContent(content) }} style={{ maxHeight: 400, overflowY: 'auto', maxHeight: 400, overflowY: 'auto', wordWrap: 'break-word', wordBreak: 'break-all', maxWidth: '100%', overflowWrap: 'break-word' }}/>
            ),
            okText: '确认',
            width: 600,
            onOk: () => {
                this.setState({ showNotice: false });
            },
        });
    }

    // 获取床上用品购买须知
    getXsCsypgmPz = () => {
        let xsid = getLoginUser()?.userId || '';
        NHFetch(`${basePath}/getXsCsypgmPz?xsid=${xsid}`, 'GET').then(res => {
            if (res && res.code === 200 && res.data) {
                const { nr, xssfytj, hjyxxzsnr, xgcsypcsxxnr } = res.data;

                this.setState({
                    csypgmxz: nr,
                    xssfytj: xssfytj,
                    hjyxxzs: hjyxxzsnr || '',
                    xgcsypcsxx: xgcsypcsxxnr || '',
                    editable: xssfytj === '0',
                    // 如果 nr 存在内容，则显示弹窗
                    showNotice: nr && nr.trim() !== '' && xssfytj !== '1',
                }, () => {
                    // 在状态更新后判断是否显示弹窗
                    if (this.state.showNotice) {
                        this.showNoticeModal(this.state.csypgmxz);
                    }
                });

                if (xssfytj === '1') {
                    this.getXsCsypgm(); // 已提交
                }
            }
        });
    }


    getXsCsypgm = () => {
        let xsid = getLoginUser()?.userId || '';
        NHFetch(`${basePath}/getXsCsypgm/${xsid}`, 'GET').then(res => { //---/sdcsjszyxy/csypgm/get/{xsid}
            if (res && res.data) {
                this.setState({
                    data: res.data,
                    csyplx: res.data.csyplx,
                    lyqd: res.data.lyqd,
                    scqy: res.data.scqy
                });
            } else {
                this.props.form.resetFields();
            }
        });
    }

    // 查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser()?.userId || '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({ nonOperationalData: res.data });

                    if (kfsj && kfsj['YXSJ'] !== '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (nohj) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = (menuList) => {
        // 菜单逻辑与原组件类似
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];

        console.log('查看整个菜单列表menuList', menuList); // 查看整个菜单列表
        console.log('查看下一个菜单项索引nextCount', nextCount); // 查看下一个菜单项索引
        console.log('查看下一个菜单项是否存在menu', menu); // 查看下一个菜单项是否存在

        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    handleOk = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                this.setState({ loading: false, saveLoading: false });
                return false;
            }

            // 验证业务逻辑
            if (this.state.csyplx === '2' && 
                this.state.lyqd === '2' && 
                !this.state.scqy) {
                message.error("请选择来源渠道并填写生产企业");
                return;
            }

            confirm({
                title: '提示',
                content: '是否确定提交?',
                okText: '确定',
                cancelText: '取消',
                onOk: () => this.handleSubmit(values)
            });
        });
    }

    handleSubmit = formData => {
        let xsid = getLoginUser().userId || '';
        if (!xsid) {
            message.error("登录已过期，请重新登录！");
            return;
        }

        this.setState({ loading: true, saveLoading: true });

        let zzbdhjid = this.getQueryString('pkid');
        
        let params = {};
        params.xsid = xsid;
        params.csyplx = this.state.csyplx;
        params.lyqd = this.state.lyqd;
        params.scqy = this.state.scqy;
        params.zzbdhjid = zzbdhjid;

        NHFetch(`${basePath}/saveXsCsypgm`, "POST", params) //---/sdcsjszyxy/csypgm/purchase/save
            .then(res => {
                if (res && res.data && res.code == 200) {
                    message.success("提交成功");
                    this.getXsCsypgm();
                } else {
                    message.error("提交失败，请重试。");
                }
                this.setState({ loading: false, editable: false, saveLoading: false });
            }).catch(() => {
                this.setState({ loading: false, saveLoading: false });
            });
    }

    handleBeddingTypeChange = (e) => {
        this.setState({ 
            csyplx: e.target.value,
            lyqd: '', 
            scqy: ''
        });
    }

    handleBeddingTypeChangeForSelect = (e) => {
        this.setState({ 
            csyplx: e,
            lyqd: '', 
            scqy: ''
        });
    }

    handleSourceChannelChange = (value) => {
        this.setState({ 
            lyqd: value,
            scqy: ''
        });
    }

    handleManufacturerChange = (e) => {
        this.setState({ scqy: e.target.value });
    }

    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList();
    }

    handleReset = () => {
        this.props.form.resetFields();
        this.setState({ 
            csyplx: '', 
            lyqd: '', 
            scqy: '' 
        });
    }

    render() {
        const { csyplx, lyqd, scqy, operable, editable, xgcsypcsxx } = this.state;
        
        return (
            <div style={{ position: 'relative' }}>
                {operable ? (
                    <div>
                        <Flex className="w1180 mt-20" align="start">
                            <SiderMenu
                                ref={"siderMenu"}
                                title="自助报到"
                                setMenuList={this.setMenuList}
                                mkbz={this.state.mkbz}
                                menuType='自助报到'
                            />
                            <Flex.Item className="page_con_r">
                                <Breadcrumb
                                    noLine
                                    list={[
                                        { name: '首页', url: '/index' },
                                        { name: '自助报到', url: '/register' },
                                        { name: this.state.hjmc }
                                    ]}
                                />
                                <div className="box">
                                    <Hint />
                                    <Form onSubmit={this.handleOk}>
                                        <TitleTop title="床上用品购买" extra={false} />
                                        <div className="p-sw">
                                            <div className="form_item" style={{ marginLeft: '7%' }}>
                                                <NHFormItem 
                                                    form={this.props.form}
                                                    required={true} 
                                                    id={'csyplx'} 
                                                    initialValue={csyplx} 
                                                    label="是否选购床上用品"
                                                >
                                                    <RadioGroup 
                                                        onChange={this.handleBeddingTypeChange} 
                                                        //value={csyplx}
                                                        disabled={!editable} 
                                                        style={{ display: "flex", flexDirection: "column", gap: "10px" }}
                                                    >
                                                        <Radio value="1">选购学校统一招标的整套床上用品</Radio>
                                                        <Radio value="2">自带床上用品</Radio>
                                                    </RadioGroup>
                                                </NHFormItem>
                                            </div>

                                            {csyplx === '1' && (
                                                <div className="notice-box" style={{ marginLeft: '7%', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                                    <p dangerouslySetInnerHTML={{__html: this.processHtmlContent(this.state.hjyxxzs)}} style={{wordWrap: 'break-word', wordBreak: 'break-all', maxWidth: '100%', overflowWrap: 'break-word'}}/>
                                                </div>
                                            )}

                                            {!csyplx && (
                                                <div className="notice-box" style={{ marginLeft: '7%', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                                                    <p dangerouslySetInnerHTML={{__html: this.processHtmlContent(this.state.xgcsypcsxx)}} style={{wordWrap: 'break-word', wordBreak: 'break-all', maxWidth: '100%', overflowWrap: 'break-word'}}/>
                                                </div>
                                            )}

                                            {csyplx === '2' && (
                                                <div className="form_item" style={{ marginLeft: '7%' }}>
                                                    <NHFormItem
                                                        form={this.props.form} 
                                                        required={true} 
                                                        id={'lyqd'} 
                                                        initialValue={lyqd} 
                                                        label="来源渠道"
                                                    >
                                                        <RadioGroup 
                                                            onChange={(e) => this.handleSourceChannelChange(e.target.value)} 
                                                            //value={lyqd}
                                                            disabled={!editable} 
                                                            style={{ display: "flex", margin: "10px 0" }}
                                                        >
                                                            <Radio value="1">家庭自制</Radio>
                                                            <Radio value="2">其他渠道购买</Radio>
                                                        </RadioGroup>
                                                    </NHFormItem>

                                                    {lyqd === '2' && (
                                                        <NHFormItem
                                                            form={this.props.form} 
                                                            required={true} 
                                                            id={'scqy'} 
                                                            initialValue={scqy} 
                                                            label="生产企业"
                                                        >
                                                            <Input
                                                                //value={scqy}
                                                                disabled={!editable} 
                                                                onChange={this.handleManufacturerChange}
                                                                placeholder="请输入生产企业名称"
                                                            />
                                                        </NHFormItem>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-center mt-50">
                                            {editable && (
                                                <>
                                                <Button type="primary" htmlType="submit">
                                                保存
                                                </Button>
                                                <Button style={{ marginLeft: '20px' }} onClick={this.handleReset}>
                                                清空
                                                </Button>
                                            </>
                                            )}

                                            {!editable && (
                                                <Button type="primary" onClick={() => this.setState({ editable: true })}>
                                                修改
                                                </Button>
                                            )}
                                            <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                                        </div>
                                    </Form>
                                </div>
                            </Flex.Item>
                        </Flex>
                        <Spin style={{ position: 'absolute', top: '300px', left: '60%' }} spinning={this.state.loading} />
                    </div>
                ) : (
                    <CommonTip hjmc={this.state.hjmc} key={this.state.mkbz} mkbz={this.state.mkbz} nonOperationalData={this.state.nonOperationalData} />
                )}
            </div>
        );
    }
}